/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { createReportResponse } from '../models/createReportResponse';
import type { getEntitiesResponse } from '../models/getEntitiesResponse';
import type { getEntityResponse } from '../models/getEntityResponse';
import type { getReportsResponse } from '../models/getReportsResponse';
import type { getReportSummaryResponse } from '../models/getReportSummaryResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class DefaultService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @deprecated
     * gets entities for a district
     * @param fid
     * @param entity
     * @param limit
     * @param offset
     * @param filter
     * @returns getEntitiesResponse the entities for the district
     * @throws ApiError
     */
    public getEntities(
        fid: string,
        entity: 'users' | 'orgs' | 'academicSessions' | 'enrollments' | 'courses' | 'classes' | 'demographics',
        limit: number = 100,
        offset?: number,
        filter?: string,
    ): Observable<getEntitiesResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/entities/{entity}',
            path: {
                'fid': fid,
                'entity': entity,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'filter': filter,
            },
        });
    }
    /**
     * @deprecated
     * gets an entity for a district
     * @param fid
     * @param entity
     * @param sourcedId
     * @returns getEntityResponse the entity
     * @throws ApiError
     */
    public getEntity(
        fid: string,
        entity: 'users' | 'orgs' | 'academicSessions' | 'enrollments' | 'courses' | 'classes' | 'demographics',
        sourcedId: string,
    ): Observable<getEntityResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/entities/{entity}/{sourcedId}',
            path: {
                'fid': fid,
                'entity': entity,
                'sourcedId': sourcedId,
            },
        });
    }
    /**
     * gets users for a district
     * @param fid
     * @param offset
     * @param limit
     * @param search
     * @param school
     * @param grade
     * @param role
     * @param status
     * @returns any the users for the district
     * @throws ApiError
     */
    public getFidUsers(
        fid: string,
        offset?: number,
        limit: number = 100,
        search?: string,
        school?: string,
        grade?: string,
        role?: string,
        status?: string,
    ): Observable<{
        users: Array<{
            /**
             * the securly id (oneroster sourcedId) of the user
             */
            sourcedId: string;
            firstName: string;
            lastName: string;
            email: string;
            role: string;
            status: string;
            identifier: string;
            grades: Array<string>;
            schools: Array<{
                sourcedId: string;
                name: string;
            }>;
            sisIds: Array<string>;
        }>;
        metadata: {
            /**
             * the request id
             */
            requestId: string;
            /**
             * the total number of users
             */
            total: number;
        };
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/users',
            path: {
                'fid': fid,
            },
            query: {
                'offset': offset,
                'limit': limit,
                'search': search,
                'school': school,
                'grade': grade,
                'role': role,
                'status': status,
            },
        });
    }
    /**
     * gets a user for a district
     * @param fid
     * @param sourcedId
     * @returns any a user object
     * @throws ApiError
     */
    public getFidUser(
        fid: string,
        sourcedId: string,
    ): Observable<{
        user: {
            /**
             * the securly id (oneroster sourcedId) of the user
             */
            sourcedId: string;
            firstName: string;
            lastName: string;
            email: string;
            identifier: string;
            role: string;
            dateLastModified: string;
            status: string;
            sisIds: Array<string>;
            grades: Array<string>;
            schools: Array<{
                sourcedId: string;
                name: string;
            }>;
            districts: Array<{
                sourcedId: string;
                name: string;
            }>;
        };
        metadata: {
            requestId: string;
        };
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/users/{sourcedId}',
            path: {
                'fid': fid,
                'sourcedId': sourcedId,
            },
        });
    }
    /**
     * gets the classes for a user
     * @param fid
     * @param sourcedId
     * @returns any array of class objects
     * @throws ApiError
     */
    public getFidUserClasses(
        fid: string,
        sourcedId: string,
    ): Observable<{
        classes: Array<{
            sourcedId: string;
            name: string;
            school: {
                sourcedId: string;
                name: string;
            };
            course: {
                sourcedId: string;
                name: string;
            };
            grade: string;
            teachers: Array<{
                sourcedId: string;
                firstName: string;
                lastName: string;
            }>;
            count: number;
        }>;
        metadata: {
            requestId: string;
        };
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/users/{sourcedId}/classes',
            path: {
                'fid': fid,
                'sourcedId': sourcedId,
            },
        });
    }
    /**
     * gets the guardians for a user
     * @param fid
     * @param sourcedId
     * @returns any array of guardian objects
     * @throws ApiError
     */
    public getFidUserGuardians(
        fid: string,
        sourcedId: string,
    ): Observable<{
        guardians: Array<{
            sourcedId: string;
            firstName: string;
            lastName: string;
            email: string;
            phone: string;
            address: {
                address1: string;
                address2: string;
                city: string;
                state: string;
                zipcode: string;
                country: string;
            };
            hasCustody: boolean;
            allowDataAccess: boolean;
        }>;
        metadata: {
            requestId: string;
        };
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/users/{sourcedId}/guardians',
            path: {
                'fid': fid,
                'sourcedId': sourcedId,
            },
        });
    }
    /**
     * gets the students for a user
     * @param fid
     * @param sourcedId
     * @returns any array of student objects
     * @throws ApiError
     */
    public getFidUserStudents(
        fid: string,
        sourcedId: string,
    ): Observable<{
        students: Array<{
            sourcedId: string;
            firstName: string;
            lastName: string;
            email: string;
            status: string;
            hasCustody: boolean;
            allowDataAccess: boolean;
            sisIds: Array<string>;
            grades: Array<string>;
            schools: Array<{
                sourcedId: string;
                name: string;
            }>;
        }>;
        metadata: {
            requestId: string;
        };
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/users/{sourcedId}/students',
            path: {
                'fid': fid,
                'sourcedId': sourcedId,
            },
        });
    }
    /**
     * gets the classes for a district/customer
     * @param fid the fid of the district/customer
     * @param limit the total number of the classes to return
     * @param offset the number of the classes to skip
     * @param search the search query - searches across sourcedId, name, course name, and school name
     * @param school the sourcedId of the school to filter by
     * @param grade the grade of the classes to filter by
     * @param status the status of the classes to filter by
     * @returns any array of class objects
     * @throws ApiError
     */
    public getFidClasses(
        fid: string,
        limit: number = 100,
        offset?: number,
        search?: string,
        school?: string,
        grade?: string,
        status?: string,
    ): Observable<{
        classes: Array<{
            /**
             * the securly id (oneroster sourcedId) of the class
             */
            sourcedId: string;
            name: string;
            headcount: number;
            teachers: Array<{
                sourcedId: string;
                firstName: string;
                lastName: string;
            }>;
            grades: Array<string>;
            course: {
                sourcedId: string;
                name: string;
            };
            school: {
                sourcedId: string;
                name: string;
            };
        }>;
        metadata: {
            requestId: string;
            total: number;
        };
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/classes',
            path: {
                'fid': fid,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'search': search,
                'school': school,
                'grade': grade,
                'status': status,
            },
        });
    }
    /**
     * gets a class for a district
     * @param fid
     * @param sourcedId
     * @returns any a class object
     * @throws ApiError
     */
    public getFidClass(
        fid: string,
        sourcedId: string,
    ): Observable<{
        class: {
            /**
             * the securly id (oneroster sourcedId) of the class
             */
            sourcedId: string;
            name: string;
            headcount: number;
            status: string;
            dateLastModified: string;
            sisIds: Array<string>;
            users: Array<{
                sourcedId: string;
                firstName: string;
                lastName: string;
                role: string;
                email: string;
                status: string;
                grades: Array<string>;
                sisIds: Array<string>;
            }>;
            grades: Array<string>;
            course: {
                sourcedId: string;
                name: string;
                code: string;
            };
            school: {
                sourcedId: string;
                name: string;
            };
            district: {
                sourcedId: string;
                name: string;
            };
            academicSessions: Array<{
                sourcedId: string;
                name: string;
            }>;
        };
        metadata: {
            /**
             * the request id
             */
            requestId: string;
        };
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/classes/{sourcedId}',
            path: {
                'fid': fid,
                'sourcedId': sourcedId,
            },
        });
    }
    /**
     * creates a report for a district
     * @param fid
     * @returns createReportResponse the reports for the district
     * @throws ApiError
     */
    public createReport(
        fid: string,
    ): Observable<createReportResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/fids/{fid}/reports',
            path: {
                'fid': fid,
            },
        });
    }
    /**
     * gets reports for a district
     * @param fid
     * @returns getReportsResponse the reports for the district
     * @throws ApiError
     */
    public getReports(
        fid: string,
    ): Observable<getReportsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/reports',
            path: {
                'fid': fid,
            },
        });
    }
    /**
     * gets a report summary for a district
     * @param fid
     * @param reportId
     * @param product
     * @returns getReportSummaryResponse the report summary
     * @throws ApiError
     */
    public getReportSummary(
        fid: string,
        reportId: number,
        product?: 'aichat' | 'aware' | 'classroom' | 'discern' | 'home' | 'filter' | 'rhithm' | 'pass' | 'flex' | 'oncall' | 'reveal',
    ): Observable<getReportSummaryResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/reports/{reportId}/summary',
            path: {
                'fid': fid,
                'reportId': reportId,
            },
            query: {
                'product': product,
            },
        });
    }
    /**
     * gets a report details CSV for a district
     * @param fid
     * @param reportId
     * @param product
     * @returns binary the report details CSV
     * @throws ApiError
     */
    public getReportDetailsCsv(
        fid: string,
        reportId: number,
        product?: 'aichat' | 'aware' | 'classroom' | 'discern' | 'home' | 'filter' | 'rhithm' | 'pass' | 'flex' | 'oncall' | 'reveal',
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/reports/{reportId}/details.csv',
            path: {
                'fid': fid,
                'reportId': reportId,
            },
            query: {
                'product': product,
            },
        });
    }
    /**
     * gets the status for a district
     * @param fid
     * @returns any the status of a fid
     * @throws ApiError
     */
    public getFidStatus(
        fid: string,
    ): Observable<{
        status: {
            state: string;
            synced: string;
        };
        metadata: {
            requestId: string;
        };
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/fids/{fid}/status',
            path: {
                'fid': fid,
            },
        });
    }
    /**
     * triggers a sync for a district
     * @param fid
     * @param full
     * @returns any metadata for an accepted sync request
     * @throws ApiError
     */
    public postFidSync(
        fid: string,
        full: boolean = false,
    ): Observable<{
        metadata: {
            /**
             * the request id
             */
            requestId: string;
        };
    }> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/fids/{fid}/syncs',
            path: {
                'fid': fid,
            },
            query: {
                'full': full,
            },
        });
    }
}
